import { render } from "./EntityDetails.vue?vue&type=template&id=5b5c9cdb"
import script from "./EntityDetails.vue?vue&type=script&lang=js"
export * from "./EntityDetails.vue?vue&type=script&lang=js"

import "./EntityDetails.vue?vue&type=style&index=0&id=5b5c9cdb&lang=scss"

import exportComponent from "/builds/2022/edf_re_aos/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__